/** Фільтри панелі списку, які скидає кнопка «Скинути фільтри» (прототип v4: пошук, тег, швидкий фільтр, сортування, колонкові фільтри). */
import type { IListViewState } from '@platform/core/types';

/**
 * Зміна стану, що скидає фільтри панелі пункту меню (подання, вкладка етапу, сторінка й збережене подання лишаються; сторінку скидає
 * listState). Вкладка етапу — вибір у поданні, а не фільтр: «Скинути фільтри» її не показує й не скидає.
 */
export const RESET_FILTERS: Partial<IListViewState> = { search: '', tagFilter: [], quickFilter: 'all', sort: '', columnFilter: '' };

/** Чи активний хоч один фільтр панелі (тоді показується «Скинути фільтри»). Чиста функція. */
export function hasActiveFilters(state: IListViewState): boolean {
  return Boolean(state.search || state.tagFilter.length || state.quickFilter !== 'all' || state.sort || state.columnFilter);
}
